export const REQUEST_RECENT_SEARCHES =
  'feature/recentSearches/REQUEST_RECENT_SEARCHES';

export const RECEIVE_RECENT_SEARCHES =
  'feature/recentSearches/RECEIVE_RECENT_SEARCHES';

export const HANDLE_RECENT_SEARCHES_ERROR =
  'feature/recentSearches/HANDLE_RECENT_SEARCHES_ERROR';
